<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 14.0039C8.55228 14.0039 9 13.5562 9 13.0039L9 5.41812L10.2929 6.71101C10.6834 7.10154 11.3166 7.10154 11.7071 6.71101C12.0976 6.32049 12.0976 5.68732 11.7071 5.2968L8.70711 2.2968C8.31658 1.90627 7.68342 1.90627 7.29289 2.2968L4.29289 5.2968C3.90237 5.68732 3.90237 6.32049 4.29289 6.71101C4.68342 7.10154 5.31658 7.10154 5.70711 6.71101L7 5.41812L7 13.0039C7 13.5562 7.44771 14.0039 8 14.0039Z"
    fill="currentColor"
  />
</template>
>
